import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const toggleUserStatus = (data, status) => {
  return apiRequestType(
    apiTypes.PUT,
    apiConstants.ADMIN.USER_MANAGEMENT.TOGGLE_USER_STATUS(status),
    data
  );
};

export default toggleUserStatus;
